export enum EsploroAssetIdentifierType {
    ISSN = 'ISSN',
    EISSN = 'EISSN',
    ISBN = 'ISBN',
    EISBN = 'EISBN',
    DOI = 'DOI',
    PMID = 'PMID',
    PMCID = 'PMCID',
    ISMN = 'ISMN',
    URI = 'URI',
    OTHER = 'OTHER',
    GOVTNUM = 'GOVTNUM',
    WOS = 'WOS',
    SCOPUS = 'SCOPUS',
    ARXIV = 'ARXIV',
    ARK = 'ARK',
    SICI = 'SICI',
    RNO = 'RNO',
    HANDLE = 'HANDLE',
    ADDITIONAL01 = 'ADDITIONAL01',
    ADDITIONAL02 = 'ADDITIONAL02',
    ADDITIONAL03 = 'ADDITIONAL03',
    ADDITIONAL04 = 'ADDITIONAL04',
    ADDITIONAL05 = 'ADDITIONAL05',
    ADDITIONAL06 = 'ADDITIONAL06',
    ADDITIONAL07 = 'ADDITIONAL07',
    ADDITIONAL08 = 'ADDITIONAL08',
    ADDITIONAL09 = 'ADDITIONAL09',
    PQDT = 'PQDT',
}

export interface EsploroAssetIdentifiersModel {
    assetIdentifiers: { [type in EsploroAssetIdentifierType]: string[] };
}
